import { Fragment as _Fragment, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, memo } from 'react';
import { activityTracker } from '../activity/index.js';
import HotJar from '../activity/trackers/hotjar.js';
import Datadog from '../activity/trackers/datadog.js';
import LinkedIn from '../activity/trackers/linkedIn.js';
import Amplitude from '../activity/trackers/amplitude.js';
const Logger = memo(({ children, ...props }) => {
    const { datadog, linkedIn, amplitude, hotjar } = props;
    useEffect(() => {
        if (datadog && !activityTracker.getTracker('datadog')) {
            const { options, ...datadogConfig } = datadog;
            const tracker = new Datadog(datadogConfig, options);
            activityTracker.subscribe(tracker);
        }
    }, [datadog?.applicationId]);
    useEffect(() => {
        if (amplitude && !activityTracker.getTracker('amplitude')) {
            const tracker = new Amplitude(amplitude);
            activityTracker.subscribe(tracker);
        }
    }, [amplitude?.clientToken]);
    useEffect(() => {
        if (linkedIn && !activityTracker.getTracker('linkedin')) {
            const tracker = new LinkedIn(linkedIn);
            activityTracker.subscribe(tracker);
        }
    }, [linkedIn?.partnerId]);
    useEffect(() => {
        if (hotjar && !activityTracker.getTracker('hotjar')) {
            const tracker = new HotJar(hotjar);
            activityTracker.subscribe(tracker);
        }
    }, [hotjar?.hjid]);
    return _jsx(_Fragment, { children: children });
});
export default Logger;
//# sourceMappingURL=index.js.map